import React from 'react';
import styles from './ContactInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import PhoneInput from '../../../components/PhoneInput';
import Icon from '../../../components/Icon';
import cn from 'classnames';

const ContactInformations = ({ center, onCenterChange, onDropdownChange, loading }) => {
    return (
        <Card className={styles.card} title="Informations de contact" classTitle="title-green">
            <div className={styles.group}>
                <PhoneInput
                    className={styles.field}
                    label="Numéro de téléphone"
                    name="phone"
                    id="phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={center?.phone || ''}
                    onChange={onCenterChange}
                    autoComplete="tel"
                />
                <TextInput
                    className={styles.field}
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="email@example.com"
                    value={center?.email || ''}
                    onChange={onCenterChange}
                    required
                />
            </div>

            <div className={styles.divider}></div>
 
            <div className={styles.submitContainer}>
              <button
                className={cn("button", styles.submit)}
                type="submit"
                disabled={loading}
              >
                {loading ? "Création en cours..." : "Créer le centre"}
              </button>
            </div>
        </Card>
    );
};

export default ContactInformations;